import { html } from '@resn/gozer-core';
import { Component, componentMixin } from '@resn/gozer-core/component';
import DomComponentMixin from '@resn/gozer-core-mixins/dom-component';
import env from 'core/env';

import './index.scss';

// <img class="imageGraphicSplit__graphic" src="${options.graphicSrc}" alt="" />
// <img class="imageGraphicSplit__image" src="${options.imgSrc}" alt="" />
const template = ({ options }) => html` <div class="imageGraphicSplit ${options.className}"></div> `;

@componentMixin(DomComponentMixin)
class ImageGraphicSplit extends Component {
    options = {
        template,
        className: '',
        graphicSrc: `${env.CDN}static/images/pages/home/home-maximizepotential-lines.svg`,
        graphicId: null,
        imgSrc: `${env.CDN}static/images/pages/home/home-maximisepotential-athlete.png`,
        imgId: null,
    };

    props = {};

    preloadComplete(assets) {
        const { graphicId, imgId } = this.options;

        const graphic = assets[graphicId].cloneNode();
        const img = assets[imgId].cloneNode();
        graphic.classList.add('imageGraphicSplit__graphic');
        img.classList.add('imageGraphicSplit__image');

        this.el.appendChild(graphic);
        this.el.appendChild(img);
    }

    async onSetup() {}
}

export default ImageGraphicSplit;
